import { render, staticRenderFns } from "./UserFormTemplate.vue?vue&type=template&id=406b12ca&scoped=true&"
import script from "./UserFormTemplate.vue?vue&type=script&lang=ts&"
export * from "./UserFormTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./UserFormTemplate.vue?vue&type=style&index=0&id=406b12ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b12ca",
  null
  
)

export default component.exports